import React from 'react';
import { SvgIcon } from '../../Icon';
import ActionButton from './ActionButton';
import { IActionButtonProps } from './types';

const SquareRemoveButton = (props: IActionButtonProps) => (
  <ActionButton {...props}>
    <SvgIcon name="icon-x" width={10} height={10} customFill="currentColor" />
  </ActionButton>
);

export default SquareRemoveButton;
